export const getNumericIdFromNestedId = (nestedId: string): number | null => {
  const str = String(nestedId);
  const last = str.split('_').pop() ?? '';
  let segment = last;
  if (last.includes(':')) {
    segment = last.split(':').pop() ?? last;
  } else if (last.includes('.')) {
    segment = last.split('.').pop() ?? last;
  }
  const n = parseInt(segment, 10);
  return Number.isFinite(n) ? n : null;
};
